export const dateRangePickerConst = {
    preSelectedRanges: [
        {
            text: 'Today',
            value: 'today',
        },
        {
            text: 'This Week',
            value: 'thisWeek',
        },
        {
            text: 'Last Week',
            value: 'lastWeek',
        },
        {
            text: 'This Month',
            value: 'thisMonth',
        },
        {
            text: 'Last Month',
            value: 'lastMonth',
        },
        {
            text: 'Last 30 Days',
            value: 'last30Days',
        },
    ],
};